import { useMutation } from "react-query";
import http from "infra/http";
import { PrevisaoOrcamentariaLancamento } from "../typings";

function useCriarLancamento(id: string) {
  return useMutation(
    (data: PrevisaoOrcamentariaLancamento) => {
      return http.post(`/v1/previsao-orcamentaria/${id}/lancamento`, data);
    },
    { retry: false }
  );
}

export default useCriarLancamento;
